'use client';

import classNames from 'classnames';
import LoadingListItem from './LoadingListItem';
import styles from './styles/styles.module.scss';
import TrailListItem from './TrailListItem';
import { TrailListItemData } from './types/types';

type TrailListProps = {
  trails: TrailListItemData[];
  variant?: 'primary' | 'inverse';
  isLoading?: boolean;
  hideDesktopArrows?: boolean;
  hideTrailNumber?: boolean;
  setIndexHovered?: (index?: number) => void;
};

const TrailList = ({
  trails,
  variant = 'primary',
  isLoading = false,
  hideDesktopArrows = false,
  hideTrailNumber = false,
  setIndexHovered
}: TrailListProps) => {
  return (
    <ol className={classNames(styles.list, styles[variant])}>
      {isLoading
        ? Array.from({ length: 7 }).map((_, i) => <LoadingListItem key={i} />)
        : trails.map((trail, index) => (
            <TrailListItem
              key={trail.slug}
              index={index}
              trail={trail}
              variant={variant}
              setHovered={() => setIndexHovered && setIndexHovered(index)}
              removeHovered={() => setIndexHovered && setIndexHovered(undefined)}
              hideDesktopArrow={hideDesktopArrows}
              hideTrailNumber={hideTrailNumber}
            />
          ))}
    </ol>
  );
};

export default TrailList;
